<template>
  <div>
    <div class="medicineNews">
      <div class="pills" v-if="!isIpad">
        <svg xmlns="http://www.w3.org/2000/svg">
          <g filter="url(#filter0_f)">
            <circle
              cx="121.145"
              cy="338.145"
              r="202.117"
              transform="rotate(-44.9976 121.145 338.145)"
              fill="url(#paint0_linear)"
            />
            <g filter="url(#filter1_i)">
              <rect
                x="260.981"
                y="192.144"
                width="8.73519"
                height="404.234"
                transform="rotate(45.0024 260.981 192.144)"
                fill="#196970"
              />
            </g>
          </g>
          <defs>
            <filter
              id="filter0_f"
              x="-89.9717"
              y="127.027"
              width="422.234"
              height="422.234"
              filterUnits="userSpaceOnUse"
              color-interpolation-filters="sRGB"
            >
              <feFlood flood-opacity="0" result="BackgroundImageFix" />
              <feBlend
                mode="normal"
                in="SourceGraphic"
                in2="BackgroundImageFix"
                result="shape"
              />
              <feGaussianBlur
                stdDeviation="4.5"
                result="effect1_foregroundBlur"
              />
            </filter>
            <filter
              id="filter1_i"
              x="-24.8672"
              y="192.144"
              width="292.025"
              height="292.002"
              filterUnits="userSpaceOnUse"
              color-interpolation-filters="sRGB"
            >
              <feFlood flood-opacity="0" result="BackgroundImageFix" />
              <feBlend
                mode="normal"
                in="SourceGraphic"
                in2="BackgroundImageFix"
                result="shape"
              />
              <feColorMatrix
                in="SourceAlpha"
                type="matrix"
                values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                result="hardAlpha"
              />
              <feOffset />
              <feGaussianBlur stdDeviation="7" />
              <feComposite
                in2="hardAlpha"
                operator="arithmetic"
                k2="-1"
                k3="1"
              />
              <feColorMatrix
                type="matrix"
                values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.35 0"
              />
              <feBlend mode="normal" in2="shape" result="effect1_innerShadow" />
            </filter>
            <linearGradient
              id="paint0_linear"
              x1="121.145"
              y1="136.028"
              x2="121.145"
              y2="540.262"
              gradientUnits="userSpaceOnUse"
            >
              <stop stop-color="#08455B" />
              <stop offset="1" stop-color="#2A8B84" />
            </linearGradient>
          </defs>
        </svg>
        <svg xmlns="http://www.w3.org/2000/svg">
          <g filter="url(#filter1_f)">
            <circle
              cx="218.316"
              cy="218.316"
              r="123.023"
              transform="rotate(-141.722 218.316 218.316)"
              fill="url(#paint1_linear)"
            />
            <rect
              x="120.096"
              y="144.192"
              width="5.31685"
              height="246.045"
              transform="rotate(-51.7215 120.096 144.192)"
              fill="#196970"
            />
          </g>
          <defs>
            <filter
              id="filter1_f"
              x="37.5312"
              y="37.5312"
              width="361.569"
              height="361.569"
              filterUnits="userSpaceOnUse"
              color-interpolation-filters="sRGB"
            >
              <feFlood flood-opacity="0" result="BackgroundImageFix" />
              <feBlend
                mode="normal"
                in="SourceGraphic"
                in2="BackgroundImageFix"
                result="shape"
              />
              <feGaussianBlur
                stdDeviation="4"
                result="effect1_foregroundBlur"
              />
            </filter>
            <linearGradient
              id="paint1_linear"
              x1="218.316"
              y1="95.2932"
              x2="218.316"
              y2="341.339"
              gradientUnits="userSpaceOnUse"
            >
              <stop stop-color="#1F6680" />
              <stop offset="1" stop-color="#2DB0A7" />
            </linearGradient>
          </defs>
        </svg>
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="109"
          height="109"
          viewBox="0 0 109 109"
          fill="none"
        >
          <g filter="url(#filter0_f2)">
            <circle
              cx="54.1288"
              cy="54.1285"
              r="39.6256"
              transform="rotate(150.002 54.1288 54.1285)"
              fill="url(#paint0_linear1)"
            />
            <g filter="url(#filter0_i2)">
              <rect
                x="20.2393"
                y="74.6816"
                width="1.71256"
                height="79.2513"
                transform="rotate(-119.998 20.2393 74.6816)"
                fill="#196970"
              />
            </g>
          </g>
          <defs>
            <filter
              id="filter0_f2"
              x="8.49609"
              y="8.49609"
              width="91.2646"
              height="91.2646"
              filterUnits="userSpaceOnUse"
              color-interpolation-filters="sRGB"
            >
              <feFlood flood-opacity="0" result="BackgroundImageFix" />
              <feBlend
                mode="normal"
                in="SourceGraphic"
                in2="BackgroundImageFix"
                result="shape"
              />
              <feGaussianBlur
                stdDeviation="3"
                result="effect1_foregroundBlur"
              />
            </filter>
            <filter
              id="filter0_i2"
              x="19.3828"
              y="33.5762"
              width="69.4912"
              height="41.1055"
              filterUnits="userSpaceOnUse"
              color-interpolation-filters="sRGB"
            >
              <feFlood flood-opacity="0" result="BackgroundImageFix" />
              <feBlend
                mode="normal"
                in="SourceGraphic"
                in2="BackgroundImageFix"
                result="shape"
              />
              <feColorMatrix
                in="SourceAlpha"
                type="matrix"
                values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                result="hardAlpha"
              />
              <feOffset />
              <feGaussianBlur stdDeviation="7" />
              <feComposite
                in2="hardAlpha"
                operator="arithmetic"
                k2="-1"
                k3="1"
              />
              <feColorMatrix
                type="matrix"
                values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.35 0"
              />
              <feBlend mode="normal" in2="shape" result="effect1_innerShadow" />
            </filter>
            <linearGradient
              id="paint0_linear1"
              x1="54.1288"
              y1="14.5029"
              x2="54.1288"
              y2="93.7541"
              gradientUnits="userSpaceOnUse"
            >
              <stop stop-color="#08455B" />
              <stop offset="1" stop-color="#2A8B84" />
            </linearGradient>
          </defs>
        </svg>
      </div>
      <div class="blog1">
        <template v-for="(item, index) in list" :key="index">
          <router-link
            :to="$i18nRoute({ name: 'NewsDetail', params: { slug: item.url } })"
            class="blog1-content"
          >
            <svg>
              <clipPath id="clipper3" clipPathUnits="objectBoundingBox">
                <path
                  d="M0.281,0 C0.265,0,0.252,0.017,0.252,0.038 V0.038 C0.252,0.059,0.239,0.076,0.223,0.076 L0.029,0.076 C0.013,0.076,0,0.093,0,0.115 V0.924 C0,0.966,0.026,1,0.057,1 H0.943 C0.974,1,1,0.966,1,0.924 V0.076 C1,0.034,0.974,0,0.943,0 H0.281"
                ></path>
              </clipPath>
            </svg>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              xmlns:xlink="http://www.w3.org/1999/xlink"
              width="238"
              height="181"
              viewBox="0 0 238 181"
              fill="none"
            >
              <g filter="url(#filter0_d1)">
                <clipPath id="myClipper4" clipPathUnits="objectBoundingBox">
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M1,0.058 C1,0.026,0.998,0,0.974,0 H0.648 C0.624,0,0.604,0.026,0.604,0.058 V0.058 C0.604,0.09,0.585,0.116,0.561,0.116 H0.061 C0.037,0.116,0.017,0.141,0.017,0.173 V0.942 C0.017,0.974,0.037,1,0.061,1 H0.974 C0.998,1,1,0.974,1,0.942 V0.058"
                    fill="black"
                    shape-rendering="crispEdges"
                  />
                </clipPath>
              </g>
              <defs>
                <filter
                  id="filter0_d1"
                  x="0"
                  y="0"
                  width="238"
                  height="181"
                  filterUnits="userSpaceOnUse"
                  color-interpolation-filters="sRGB"
                >
                  <feFlood flood-opacity="0" result="BackgroundImageFix" />
                  <feColorMatrix
                    in="SourceAlpha"
                    type="matrix"
                    values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                    result="hardAlpha"
                  />
                  <feOffset dy="4" />
                  <feGaussianBlur stdDeviation="2" />
                  <feComposite in2="hardAlpha" operator="out" />
                  <feColorMatrix
                    type="matrix"
                    values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
                  />
                  <feBlend
                    mode="normal"
                    in2="BackgroundImageFix"
                    result="effect1_dropShadow"
                  />
                  <feBlend
                    mode="normal"
                    in="SourceGraphic"
                    in2="effect1_dropShadow"
                    result="shape"
                  />
                </filter>
              </defs>
            </svg>
            <ImageContainer
              class="img"
              :src="item.image.medium"
              :alt="item.title"
              :thumb="item.image.thumbnail"
            />
            <h2>{{ item.sub_category.name }}</h2>
            <h1>
              {{ item.title }}
            </h1>
            <p v-if="!isIpad">
              {{ item.brief }}
            </p>
            <h3>
              {{ handleDate(item.pub_date) }}, {{ handleTime(item.pub_date) }}
            </h3>
          </router-link>
          <div class="border-container" v-if="!isIpad">
            <div class="border" v-if="index !== 4"></div>
          </div>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
import { ref, onBeforeUnmount } from "vue";
import { useFormatter } from "@/utils/formatter";
import ImageContainer from "@/components/ImageContainer";
export default {
  components: {
    ImageContainer,
  },
  props: {
    list: {
      type: Array,
      required: true,
    },
  },
  setup() {
    const isIpad = ref();

    const handleResize = () => {
      isIpad.value = window.innerWidth <= 1366;
    };

    if (typeof window !== "undefined") {
      isIpad.value = window.innerWidth <= 1366;
      window.addEventListener("resize", handleResize);
    }

    onBeforeUnmount(() => {
      if (typeof window !== "undefined") {
        window.removeEventListener("resize", handleResize);
      }
    });

    return {
      isIpad,
      ...useFormatter(),
    };
  },
};
</script>

<style lang="scss" scoped>
.medicineNews {
  position: relative;
  padding-top: 4.2vw;
  padding-bottom: 7vw;
  .pills {
    position: absolute;
    width: 100%;
    height: 100%;
    svg {
      position: absolute;
      &:nth-child(1) {
        width: 35.75vw;
        height: 35.75vw;
        left: -3vw;
      }
      &:nth-child(2) {
        width: 13.021vw;
        height: 22.76vw;
        right: -3vw;
        bottom: 0;
      }
      &:nth-child(3) {
        width: 8vw;
        height: 8vw;
        left: 55vw;
        bottom: 10vw;
      }
    }
  }
  .blog1 {
    display: flex;
    justify-content: space-between;
    position: relative;
    width: 100%;
    .blog1-content {
      width: 16.875vw;
      svg {
        position: absolute;
        width: 0;
        height: 0;
      }
      .img {
        width: 17vw;
        height: 12.6vw;
        border-radius: 0.521vw;
      }
      h2 {
        font-size: 0.85vw;
        line-height: 1.3vw;
        font-weight: 400;
        color: var(--light-b-color);
        font-family: "Open Sans", sans-serif;
        font-style: normal;
      }
      h1 {
        font-size: 1.1vw;
        line-height: 1.3vw;
        font-weight: 400;
        color: var(--light-m-color);
        margin-top: 0.2vw;
        margin-bottom: 0.5vw;
        font-family: "Alice", serif;
        font-style: normal;
      }
      p {
        font-size: 0.83vw;
        line-height: 1.3vw;
        font-weight: 400;
        color: var(--light-p-color);
      }
      h3 {
        font-size: 0.85vw;
        line-height: 1.3vw;
        font-weight: 300;
        color: var(--light-b-color);
        text-align: right;
        margin-top: 0.6vw;
        font-family: "Open Sans", sans-serif;
        font-style: normal;
      }
    }
    .border-container {
      .border {
        margin: 0 1vw;
        width: 1px;
        height: 100%;
        background: linear-gradient(
          180deg,
          rgba(255, 255, 255, 0) 0%,
          rgba(255, 255, 255, 0.2) 52.08%,
          rgba(255, 255, 255, 0) 100%
        );
      }
    }
  }
}
@media screen and (max-width: 1510px) {
  .medicineNews {
    .pills {
      svg {
        &:nth-child(2) {
          right: -2.3vw;
        }
      }
    }
  }
}
@media screen and (max-width: 1366px) {
  .medicineNews {
    position: relative;
    padding-bottom: 15vw;
    svg {
      position: absolute;
      width: 0;
    }
    .blog1 {
      display: grid;
      gap: 3vw;
      grid-template-areas:
        "content1 content1 content1 content2 content2 content2"
        "content3 content3 content4 content4 content5 content5";
      .border {
        display: none;
      }
      .blog1-content {
        display: grid;
        grid-template-areas:
          "newsCategory"
          "newsImage"
          "newsTitle"
          "publishedDate";
        max-width: 100vw;
        position: relative;
        .img {
          grid-area: newsImage;
          clip-path: url(#clipper3);
        }
        h2 {
          grid-area: newsCategory;
          font-size: 1.8vw;
          font-family: "Open Sans", sans-serif;
          font-style: normal;
        }
        h1 {
          grid-area: newsTitle;
          font-size: 1.9vw;
          line-height: 3vw;
          font-family: "Alice", serif;
          font-style: normal;
        }
        h3 {
          grid-area: publishedDate;
          text-align: left;
          font-size: 1.7vw;
          line-height: 1.8vw;
          font-weight: 300;
          font-family: "Open Sans", sans-serif;
          font-style: normal;
          margin: 0;
        }

        &:nth-child(1) {
          grid-area: content1;
        }
        &:nth-child(2) {
          grid-area: content2;
        }
        &:nth-child(3) {
          grid-area: content3;
        }
        &:nth-child(4) {
          grid-area: content4;
        }
        &:nth-child(5) {
          grid-area: content5;
        }
        &:nth-child(1),
        &:nth-child(2) {
          width: 44.5vw;
          .img {
            width: 44.5vw;
            height: 33.5vw;
          }
          h2 {
            margin-left: 0vw;
            margin-bottom: -1.3vw;
          }
        }
        &:nth-child(3),
        &:nth-child(4),
        &:nth-child(5) {
          position: relative;
          .img {
            width: 29.5vw;
            height: 22.2vw;
            clip-path: url(#myClipper4);
          }
          h2 {
            position: absolute;
            top: 0.5vw;
            left: 1.5vw;
          }
        }
      }
    }
  }
}
@media screen and (max-width: 414px) {
  .medicineNews {
    .border-linear {
      width: 90vw;
      height: 0.5vw;
      background: var(--light);
    }
    .blog1 {
      display: flex;
      flex-direction: column;
      max-width: 100vw;
      .blog1-content {
        padding-bottom: 2vw;
        padding-top: 2vw;
        h1 {
          font-size: 3vw;
          line-height: 3.5vw;
          margin-top: 1vw;
          margin-bottom: 1vw;
        }
        h2 {
          font-size: 2.5vw;
          width: 30vw;
        }
        h3 {
          font-size: 2.5vw;
        }
        &:nth-child(1),
        &:nth-child(5) {
          width: 80vw;
          text-align: center;
          .img {
            clip-path: url(#clipper3);
            width: 80vw;
            height: 53.382vw;
            display: flex;
            justify-content: center;
            align-items: center;
          }
          h2 {
            position: relative;
            top: 2.5vw;
            text-align: center;
            height: 100%;
            margin-left: -4.831vw;
            margin-bottom: 0vw;
          }
          h3 {
            text-align: center;
          }
        }
        &:nth-child(2),
        &:nth-child(3),
        &:nth-child(4) {
          width: 80vw;
          padding-top: 5vw;
          padding-left: 5vw;
          .img {
            display: none;
          }
          h2 {
            margin-left: 0;
            left: 0;
          }
          h1 {
            margin-bottom: 1.449vw;
            margin-top: 2.5vw;
          }
        }
        &:nth-child(2) {
          border-top: 1px solid var(--light);
        }
        &:nth-child(4) {
          border-bottom: 1px solid var(--light);
          padding-bottom: 4.831vw;
        }
      }
    }
  }
}
</style>